import {
    createSlice,
    PayloadAction,
    createAsyncThunk
} from '@reduxjs/toolkit';
import type { RootState } from 'app/store';
import { getData, postFormData, getExamTypeId } from 'utils/service';
// declaring the types for our state
export type FilterState = {
    groupData: any;
    subjectData: any;
    chapterData: any;
    topicData: any;
    categoryData: any;
    availableBooksData: any;
    questionData: any;
    questionDetail: any;
    questionsNotes: any;
    questionsReference: any;
    pending: boolean;
    error: boolean;
    selectedFilters: any;
    isArrowEnable: any;
    isQuestionRefresh: boolean;
};

const initialState: FilterState = {
    isQuestionRefresh: true,
    isArrowEnable: true,
    groupData: [],
    subjectData: [],
    chapterData: [],
    topicData: [],
    categoryData: [],
    availableBooksData: [],
    questionData: [],
    questionDetail: {},
    questionsNotes: [],
    questionsReference: null,
    pending: false,
    error: false,
    selectedFilters: {
        group_id: null,
        subject_id: null,
        chapter_id: null,
        topic_id: null,
        category_id: null,
        own_data: [],
        available_in: [],
        doubt: false,
        done: false,
        lmr: false
    }
};

// This action is what we will call using the dispatch in order to trigger the API call.
export const getGroupData = createAsyncThunk('api/questions_filter_list_group', async () => {
    let response: any = await getData('questions_filter_list_group', { exam_type_id: getExamTypeId() });
    if (response.success === "true") {
        return response.data
    }
    return [];
});

export const getSubjectData = createAsyncThunk('api/questions_filter_list_subject', async (data:any) => {
    const {group_id} = data;
    let response: any = await getData('questions_filter_list_subject', { group_id: group_id });
    if (response.success === "true") {
        return response.data
    }
    return [];
});


export const getChaptersData = createAsyncThunk('api/chapters', async (data:any) => {
    const {subject_id} = data;
    let response: any = await getData('questions_filter_list_chapters', { subject_id: subject_id });
    if (response.success === "true") {
        return response.data
    }
    return [];
});

export const getTopicsData = createAsyncThunk('api/topics', async (data:any) => {
    const {chapter_id} = data;
    let response: any = await getData('questions_filter_list_topics', { chapter_id: chapter_id });
    if (response.success === "true") {
        return response.data
    }
    return [];
});

export const getCategoryData = createAsyncThunk('api/categories', async (data:any) => {
    // const {chapter_id} = data;
    let response: any = await getData('questions_filter_list_categories', { });
    if (response.success === "true") {
        return response.data
    }
    return [];
});

export const getAvailableInBooksData = createAsyncThunk('api/available_in_books', async (data:any) => {
    const {subject_id} = data;
    let response: any = await getData('questions_filter_list_books', { subject_id: subject_id });
    if (response.success === "true") {
        let newData:any = [];
        response.data.map((item:any) =>  {
            newData.push({label: item.book_name, value: item.id})
        });
        return newData;
    }
    return [];
});

export const getSearchedQuestions = createAsyncThunk('api/search_questions', async (data:any) => {
    // const {subject_id} = data;
    let response: any = await postFormData('search_questions', data);
    if (response.success === "true") {
        return response.data;
    }
    return [];
});

export const updateQuestionsDIL = createAsyncThunk('api/questions_doubt_imp_lmr', async (data:any) => {
    // const {subject_id} = data;
    let response: any = await postFormData('questions_doubt_imp_lmr', data);
    if (response.success === "true") {
        return response.data;
    }
    return [];
});

export const getQuestionsNotes = createAsyncThunk('api/questions_notes', async (data:any) => {
    // const {subject_id} = data;
    let response: any = await postFormData('questions_notes', data);
    if (response.success === "true") {
        return response.data;
    }
    return [];
});

export const getQuestionsReference = createAsyncThunk('api/questions_reference', async (data:any) => {
    // const {subject_id} = data;
    let response: any = await postFormData('questions_reference', data);
    if (response.success === "true") {
        return response.data;
    }
    return null;
});

export const filterSlice:any = createSlice({
    name: 'filter',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions. 
    // In this example, 'increment', 'decrement' and 'incrementByAmount' are actions. They can be triggered from outside this slice, anywhere in the app. 
    // So for example, if we make a dispatch to the 'increment' action here from the index page, it will get triggered and change the value of the state from 0 to 1.
    reducers: {
        toggleArrorEnable: (state, action: PayloadAction<boolean>) =>{
            state.isArrowEnable = action.payload
        },
        setQuestionDetails: (state, action: PayloadAction<number>) =>{
            // console.log('action.payload...',action.payload)
            state.questionDetail = action.payload
        },
        setQuestionData: (state, action: PayloadAction<number>) =>{
            state.questionData = action.payload
        },
        setSelectedFilters: (state, action: PayloadAction<object>) =>{
            state.selectedFilters = action.payload
        },
        resetQuestionsData: (state, action: PayloadAction<object>) =>{
            state.groupData  = [];
            state.subjectData = [];
            state.chapterData = [];
            state.topicData = [];
            state.categoryData = [];
            state.availableBooksData = [];
            state.questionData = [];
            state.isQuestionRefresh = true;
            state.questionDetail = {};
            state.pending = false;
            state.error = false;
            state.questionsNotes = [];
            state.selectedFilters = {
                group_id: null,
                subject_id: null,
                is_fastrack_active: false,
                chapter_id: null,
                topic_id: null,
                category_id: null,
                available_in: [],
                own_data: [],
                doubt: false,
                done: false,
                lmr: false
            }
        },
        setQuestionsNotes: (state, action: PayloadAction<object>) =>{
            state.questionsNotes = action.payload
        },
        setQuestionsReference: (state, action: PayloadAction<object>) =>{
            state.questionsReference = action.payload
        },
    },

    extraReducers: builder => {
        builder
            .addCase(getGroupData.pending, state => {
                state.pending = true;
            })
            .addCase(getGroupData.fulfilled, (state, { payload }) => {
                state.pending = false;
                state.groupData = payload;
            })
            .addCase(getGroupData.rejected, state => {
                state.pending = false;
                state.error = true;
            })
            .addCase(getSubjectData.pending, state => {
                state.pending = true;
            })
            .addCase(getSubjectData.fulfilled, (state, { payload }) => {
                state.pending = false;
                state.subjectData = payload;
            })
            .addCase(getSubjectData.rejected, state => {
                state.pending = false;
                state.error = true;
            })
            .addCase(getChaptersData.pending, state => {
                state.pending = true;
            })
            .addCase(getChaptersData.fulfilled, (state, { payload }) => {
                state.pending = false;
                state.chapterData = payload;
            })
            .addCase(getChaptersData.rejected, state => {
                state.pending = false;
                state.error = true;
            })
            .addCase(getTopicsData.pending, state => {
                state.pending = true;
            })
            .addCase(getTopicsData.fulfilled, (state, { payload }) => {
                state.pending = false;
                state.topicData = payload;
            })
            .addCase(getTopicsData.rejected, state => {
                state.pending = false;
                state.error = true;
            })
            .addCase(getCategoryData.pending, state => {
                state.pending = true;
            })
            .addCase(getCategoryData.fulfilled, (state, { payload }) => {
                state.pending = false;
                state.categoryData = payload;
            })
            .addCase(getCategoryData.rejected, state => {
                state.pending = false;
                state.error = true;
            })
            .addCase(getAvailableInBooksData.pending, state => {
                state.pending = true;
            })
            .addCase(getAvailableInBooksData.fulfilled, (state, { payload }) => {
                state.pending = false;
                state.availableBooksData = payload;
            })
            .addCase(getAvailableInBooksData.rejected, state => {
                state.pending = false;
                state.error = true;
            }).addCase(getSearchedQuestions.pending, state => {
                state.pending = true;
            })
            .addCase(getSearchedQuestions.fulfilled, (state, { payload }) => {
                state.pending = false;
                state.questionData = payload;
                state.isQuestionRefresh = !state.isQuestionRefresh;
                state.isArrowEnable = true;
            })
            .addCase(getSearchedQuestions.rejected, state => {
                state.pending = false;
                state.error = true;
            }).addCase(getQuestionsNotes.fulfilled, (state, { payload }) => {
                state.questionsNotes = payload;
            }).addCase(getQuestionsReference.fulfilled, (state, { payload }) => {
                state.questionsReference = payload;
            });
            
            
    },

});
// Here we are just exporting the actions from this slice, so that we can call them anywhere in our app.
export const {
    resetQuestionsData,
    setQuestionDetails,
    setQuestionData,
    toggleArrorEnable,
    setSelectedFilters,
    setQuestionsNotes,
    setQuestionsReference
} = filterSlice.actions;

// calling the above actions would be useless if we could not access the data in the state. So, we use something called a selector which allows us to select a value from the state.
export const selectQuestionFilter = (state: RootState) => state.filters;

// exporting the reducer here, as we need to add this to the store
export default filterSlice.reducer;